var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatP({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45625 9.67578C5.96875 9.67578 5.59375 10.0508 5.59375 10.5383C5.59375 11.0258 5.96875 11.4008 6.45625 11.4008C6.94375 11.4008 7.31875 11.0258 7.31875 10.5383C7.31875 10.0508 6.90625 9.67578 6.45625 9.67578Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6281 9.67578C11.1406 9.67578 10.7656 10.0508 10.7656 10.5383C10.7656 11.0258 11.1406 11.4008 11.6281 11.4008C12.1156 11.4008 12.4906 11.0258 12.4906 10.5383C12.4906 10.0508 12.0781 9.67578 11.6281 9.67578Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 9.67578C16.3125 9.67578 15.9375 10.0508 15.9375 10.5383C15.9375 11.0258 16.3125 11.4008 16.8 11.4008C17.2875 11.4008 17.6625 11.0258 17.6625 10.5383C17.6625 10.0508 17.2875 9.67578 16.8 9.67578Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 2.96289H3.00312C1.72812 2.96289 0.640625 4.01289 0.640625 5.32539V19.4629C0.640625 20.0629 0.978125 20.6254 1.54062 20.8879C1.76562 21.0004 1.99062 21.0379 2.21562 21.0379C2.59062 21.0379 2.92813 20.9254 3.22813 20.6629L6.41562 18.0379H15.8281C19.9906 18.0379 23.3656 14.6629 23.3656 10.5004C23.3656 6.33789 19.9531 2.96289 15.8281 2.96289ZM15.8281 16.3504H6.11562C5.92812 16.3504 5.74062 16.4254 5.59062 16.5379L2.36563 19.2004V5.32539C2.36563 4.95039 2.66563 4.65039 3.04063 4.65039H15.8656C19.0906 4.65039 21.7156 7.27539 21.7156 10.5004C21.6781 13.7254 19.0531 16.3504 15.8281 16.3504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatP);
export default __webpack_public_path__ + "static/media/chat-p.a594a5b3f7ffa88e36ae81ecf71373d0.svg";
export { ForwardRef as ReactComponent };